import { call, put, takeLatest } from "redux-saga/effects";
import { IBaseResponse } from "../../../interfaces/base";
import { IFetchVodsAction } from "../../../interfaces/store/vods-interface";
import {
  fetchVodsSuccess,
  fetchVodsFailed,
  fetchVodsStart,
} from "./vods-slice";
import { searchVodsApi } from "../../../api/vod";

function* _fetchVods({ payload }: IFetchVodsAction) {
  try {
    const { sort, filter, pagination, search } = payload;

    const response: IBaseResponse = yield call(searchVodsApi, {
      sort: sort || { sortBy: "updatedAt", sortOrder: -1 },
      search,
      filter,
      pagination,
    });

    if (response.error) {
      yield put(fetchVodsFailed(response.error));
    } else {
      yield put(fetchVodsSuccess({ data: response.data }));
    }
  } catch (error: any) {
    console.log("error:", error);
    yield put(fetchVodsFailed({ message: error.message }));
  }
}

function* vodsSaga() {
  yield takeLatest(fetchVodsStart.type, _fetchVods);
}

export default vodsSaga;
